/* ------------------------------------------------------------------ */
/*  Access-control group-name helpers (pure, unit-tested)              */
/* ------------------------------------------------------------------ */
/*
 * Access Rules that target a single user / single charger create helper
 * "auto groups" behind the scenes, named "(RuleName drivers)" and
 * "(RuleName chargers)". These are hidden from the Driver/Charger Groups
 * panels and are managed through the rule, not by hand.
 *
 * Keeping the naming convention and its detection in one place lets both
 * the page and its tests agree on what counts as an auto/reserved name.
 */

/** Auto-created group name patterns: "(Name chargers)" and "(Name drivers)" */
export const AUTO_CHARGER_GROUP_RE = /^\(.+ chargers\)$/;
export const AUTO_DRIVER_GROUP_RE = /^\(.+ drivers\)$/;

/** True when `name` matches the reserved shape used by rule-managed groups. */
export function isAutoGroup(name: string): boolean {
  return AUTO_CHARGER_GROUP_RE.test(name) || AUTO_DRIVER_GROUP_RE.test(name);
}

/** Auto-created charger group name for a rule/policy: "(Name chargers)". */
export function autoGroupName(policyName: string): string {
  return `(${policyName} chargers)`;
}

/** Auto-created driver group name for a rule: "(Name drivers)". */
export function autoDriverGroupName(ruleName: string): string {
  return `(${ruleName} drivers)`;
}

/**
 * A manually-typed group name is reserved iff it collides with the
 * auto-group naming convention. Trimming matches how the create handlers
 * normalize input before sending it to the server.
 */
export function isReservedManualGroupName(name: string): boolean {
  return isAutoGroup(name.trim());
}

/**
 * Catalog key of the explanation shown when a manual group name is reserved;
 * callers translate it at render or submit time. The auto-group names above are
 * persisted identifiers and stay English whatever the UI language.
 */
export const RESERVED_GROUP_NAME_MESSAGE_KEY = "operator.orgs.access.reserved_group_name";
